import * as AWS from 'aws-sdk';

AWS.config.update({
  region: 'us-east-2',
  endpoint: 'https://dynamodb.us-east-2.amazonaws.com',
  accessKeyId: 'AKIAXCKSYQBXFXTX254J',
  secretAccessKey: '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'
});

const docClient = new AWS.DynamoDB.DocumentClient();

export const getRecipesFromDB = () => {
  var params = {
    TableName: 'recipes'
  }

  return new Promise((resolve) => {
    docClient.scan(params, function (err, data) {
      if (!err) {
        resolve(data.Items);
      }
    });
  });
};

export const getRecipeFromDB = (recipeId) => {
  var params = {
    TableName: 'recipes',
    Key: {
      recipeId: recipeId
    },
  }

  return new Promise((resolve) => {
    docClient.get(params, function (err, data) {
      if (!err) {
        resolve(data.Item);
      }
    });
  });
};